import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import "dayjs/locale/ru"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone" // Import timezone plugin
import localeData from "dayjs/plugin/localeData"

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale("ru")
dayjs.extend(localeData)
dayjs.tz.setDefault("Europe/Moscow")

export const withDayjs = (Component: React.ComponentType) => () =>
  (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
      <Component />
    </LocalizationProvider>
  )
